import React from 'react';

import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import useWindowWidth from '../../hooks/useWindowWidth';

import { Button } from '../../components/Button';
import { CtaBlock } from '../../components/CtaBlock';
import { Footer } from '../../components/Footer';
import { FundingNotice } from '../../components/FundingNotice';
import { Header } from '../../components/Header';
import { Tag } from '../../components/Tag';
import './style.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';

import PreviewBox from '../../components/PreviewBox/PreviewBox';
import EmbeddedVideo from '../../components/EmbeddedVideo/EmbeddedVideo';

import ResourceStore from '../../stores/ResourceStore';
import ServerSettingsStore from '../../stores/ServerSettingsStore';

export const HomepageDesktop = ({ shareFeedbackEmailAddress }) => {
    const navigate = useNavigate();

    const resourceStore = ResourceStore((state) => state);
    const serverSettingsStore = ServerSettingsStore((state) => state);

	const vw = useWindowWidth();	
	const isViewingWithMobile = vw < 576;

    useEffect(() => {
        resourceStore.loadSearchOptions();
        resourceStore.loadNewestArticlesForFrontPage();
        serverSettingsStore.load();

        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="homepage-desktop" data-tokens-mode="desktop">
            <Header
                className="header-instance"
                style="desktop"
                shareFeedbackEmailAddress={shareFeedbackEmailAddress}
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />

            <div className="main-content-wrapper">
                <div className="main-content">
                    <div className="header-section">
                        <p className="main-heading">
                            Forschung für die Praxis – Praxis für die Forschung
                        </p>

                        <p className="subtitle">
                            digital &nbsp;&nbsp; | &nbsp;&nbsp; frei
                            &nbsp;&nbsp; | &nbsp;&nbsp; forschungsbasiert
                        </p>
                    </div>

                    <div className="content-grid">
                        <div className="cta-column">
                            <CtaBlock
                                useHomepageCtaBlockStyleButton={true}
                                buttonTextLink={
                                    <FontAwesomeIcon
                                        size="2x"
                                        style={{
                                            height: '0.75em',
                                            width: '2em',
                                            padding: '0.05em',
                                        }}
                                        icon={faCaretRight}
                                        fixedWidth
                                    />
                                }
                                className="header-instance"
                                stateProp="default"
                                style="default"
                                text="Aktuelle Forschungsbefunde zum Lehren und Lernen mit digitalen Medien für Sie aufbereitet."
                                title="Kompaktberichte"
                                showLink={true}
                                onClick={() => {
                                    resourceStore.toggleFilterParamSetting(
                                        'SEARCH_CRIT_RESOURCE_TYPE',
                                        'Kompaktbericht',
                                    );
                                    navigate('/directory');
                                }}
                            />
                            <CtaBlock
                                useHomepageCtaBlockStyleButton={true}
                                buttonTextLink={
                                    <FontAwesomeIcon
                                        size="2x"
                                        style={{
                                            height: '0.75em',
                                            width: '2em',
                                            padding: '0.05em',
                                        }}
                                        icon={faCaretRight}
                                        fixedWidth
                                    />
                                }
                                className="header-instance"
                                stateProp="default"
                                style="default"
                                text="Mit Lehrkräften entwickelte, evidenzbasierte digitale Unterrichtskonzepte für verschiedene Fächer."
                                title="Unterrichtskonzepte"
                                showLink={true}
                                onClick={() => {
                                    resourceStore.toggleFilterParamSetting(
                                        'SEARCH_CRIT_RESOURCE_TYPE',
                                        'Unterrichtskonzept',
                                    );
                                    navigate('/directory');
                                }}
                            />
                            <CtaBlock
                                useHomepageCtaBlockStyleButton={true}
                                buttonTextLink={
                                    <FontAwesomeIcon
                                        size="2x"
                                        style={{
                                            height: '0.75em',
                                            width: '2em',
                                            padding: '0.05em',
                                        }}
                                        icon={faCaretRight}
                                        fixedWidth
                                    />
                                }
                                className="header-instance"
                                stateProp="default"
                                style="default"
                                text="Videos zu Forschungsbefunden, wissenschaftlichen Methoden, pädagogischen Ansätzen und digitalen Anwendungen im Unterricht."
                                title="Erklärvideos"
                                showLink={true}
                                onClick={() => {
                                    resourceStore.toggleFilterParamSetting(
                                        'SEARCH_CRIT_RESOURCE_TYPE',
                                        'Erklärvideo',
                                    );
                                    navigate('/directory');
                                }}
                            />
                        </div>

                        <div className="gallery">
                            {buildTitleMedia(serverSettingsStore.serverSettings, isViewingWithMobile)}
                        </div>

                        <div style={{ width: '100%', overflow: 'hidden' }}>
                            <div
                                className="h-3"
                                style={{
                                    fontSize: '2.0em',
                                    marginTop: '30px',
                                    marginBottom: '15px',
                                }}
                            >
                                Neu auf duo
                            </div>

                            <div className="cards-swiper">
                                {null != resourceStore.portalResources &&
                                0 < resourceStore.portalResources.length ? (
                                    <PreviewBox
                                        element={
                                            resourceStore.portalResources[0]
                                        }
                                        i={0}
                                        shouldCenter={true}
                                        shouldMaxHeight={true}
                                        showDate={
                                            serverSettingsStore.serverSettings
                                                .isFrontPageResourceCreationDateVisible
                                        }
                                    />
                                ) : null}

                                {null != resourceStore.portalResources &&
                                1 < resourceStore.portalResources.length ? (
                                    <PreviewBox
                                        element={
                                            resourceStore.portalResources[1]
                                        }
                                        i={0}
                                        shouldCenter={true}
                                        shouldMaxHeight={true}
                                        showDate={
                                            serverSettingsStore.serverSettings
                                                .isFrontPageResourceCreationDateVisible
                                        }
                                    />
                                ) : null}

                                {null != resourceStore.portalResources &&
                                2 < resourceStore.portalResources.length ? (
                                    <PreviewBox
                                        element={
                                            resourceStore.portalResources[2]
                                        }
                                        i={0}
                                        shouldCenter={true}
                                        shouldMaxHeight={true}
                                        showDate={
                                            serverSettingsStore.serverSettings
                                                .isFrontPageResourceCreationDateVisible
                                        }
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {buildSearchPanel(resourceStore)}

            <FundingNotice />

            <Footer
                className="header-instance"
                logosPartnersGroupLogoPartnerBundesministerium="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg"
                property1="desktop"
            />
        </div>
    );

	function buildTitleMedia(serverSettings, isViewingWithMobile){
		if(null == serverSettings){
			return null;
		}
		else if(serverSettings.isMainPageVideoUrlVisible){
			return <div className={isViewingWithMobile ? "front-page-video-mobile" : "front-page-video"}>
				<EmbeddedVideo src={serverSettings.mainPageVideoUrl} />
			</div>;
		}
		else {
			return <img
                className="screenshot"
                alt="Screenshot"
                src="/img/screenshot-2024-04-24-at-12-46-1.png"
            />;
		}		 
	}

    function buildSearchPanel(resourceStore) {
        const filterSettings = resourceStore.filterSettings;

        return (
            <div className="search-section">
                <div className="search-content">
                    <div className="search-header">
                        <p
                            className="search-title"
                            style={{ marginBottom: '0px' }}
                        >
                            Ich interessiere mich für...
                        </p>

                        <p
                            className="search-title"
                            style={{
                                fontSize: '1.5em',
                                fontWeight: 'normal',
                                marginTop: '-35px',
                            }}
                        >
                            Klicken Sie, um passende Ressourcen zu finden
                        </p>

                        <div className="categories-grid">
                            <div className="category-column">
                                {filterSettings.slice(0, 1).map((area, i) => {
                                    return (
                                        <div
                                            key={'homepage-tags-div-' + i}
                                            className="category-list"
                                        >
                                            <div className="category-item">
                                                <div className="category-header">
                                                    <div className="category-title">
                                                        {area.userFriendlyLabel}
                                                    </div>
                                                </div>

                                                <div className="tags-container">
                                                    {area.subAreas.map(
                                                        (subArea, j) => {
                                                            return (
                                                                <Tag
                                                                    key={
                                                                        'homepage-tag-' +
                                                                        subArea.label +
                                                                        '-' +
                                                                        j
                                                                    }
                                                                    className="tag-instance"
                                                                    size="default"
                                                                    stateProp={
                                                                        subArea.isActive
                                                                            ? 'active'
                                                                            : 'default'
                                                                    }
                                                                    style="default"
                                                                    text={
                                                                        subArea.label
                                                                    }
                                                                    onClick={() => {
                                                                        resourceStore.toggleFilterParamSetting(
                                                                            area.label,
                                                                            subArea.label,
                                                                        );

                                                                        if (
                                                                            area.isCollapsed
                                                                        ) {
                                                                            resourceStore.toggleAreaCollapsedState(
                                                                                area.label,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="category-column">
                                {filterSettings.slice(1, 2).map((area, i) => {
                                    return (
                                        <div
                                            key={'homepage-tags-div-' + i}
                                            className="category-list"
                                        >
                                            <div className="category-item">
                                                <div className="category-header">
                                                    <div className="category-title">
                                                        {area.userFriendlyLabel}
                                                    </div>
                                                </div>

                                                <div className="tags-container">
                                                    {area.subAreas.map(
                                                        (subArea, j) => {
                                                            return (
                                                                <Tag
                                                                    key={
                                                                        'homepage-tag-' +
                                                                        subArea.label +
                                                                        '-' +
                                                                        j
                                                                    }
                                                                    className="tag-instance"
                                                                    size="default"
                                                                    stateProp={
                                                                        subArea.isActive
                                                                            ? 'active'
                                                                            : 'default'
                                                                    }
                                                                    style="default"
                                                                    text={
                                                                        subArea.label
                                                                    }
                                                                    onClick={() => {
                                                                        resourceStore.toggleFilterParamSetting(
                                                                            area.label,
                                                                            subArea.label,
                                                                        );

                                                                        if (
                                                                            area.isCollapsed
                                                                        ) {
                                                                            resourceStore.toggleAreaCollapsedState(
                                                                                area.label,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="category-column">
                                {filterSettings.slice(3).map((area, i) => {
                                    return (
                                        <div
                                            key={'homepage-tags-div-' + i}
                                            className="category-list"
                                        >
                                            <div className="category-item">
                                                <div className="category-header">
                                                    <div className="category-title">
                                                        {area.userFriendlyLabel}
                                                    </div>
                                                </div>

                                                <div className="tags-container">
                                                    {area.subAreas.map(
                                                        (subArea, j) => {
                                                            return (
                                                                <Tag
                                                                    key={
                                                                        'homepage-tag-' +
                                                                        subArea.label +
                                                                        '-' +
                                                                        j
                                                                    }
                                                                    className="tag-instance"
                                                                    size="default"
                                                                    stateProp={
                                                                        subArea.isActive
                                                                            ? 'active'
                                                                            : 'default'
                                                                    }
                                                                    style="default"
                                                                    text={
                                                                        subArea.label
                                                                    }
                                                                    onClick={() => {
                                                                        resourceStore.toggleFilterParamSetting(
                                                                            area.label,
                                                                            subArea.label,
                                                                        );

                                                                        if (
                                                                            area.isCollapsed
                                                                        ) {
                                                                            resourceStore.toggleAreaCollapsedState(
                                                                                area.label,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <Button
                        className="tag-instance"
                        status="default"
                        style="default"
                        textLink="Los geht's!"
                        onClick={() => {
                            navigate('/directory');
                        }}
                    />
                </div>
            </div>
        );
    }
};
